<app-spinner></app-spinner>

<div class="container" style="max-width: 75% !important;" id="contact" *ngIf="!this.apierror">

  <div>
    <h1 class="text-center">Kunde {{ this.getOperation() }}</h1>
  </div>

  <div class="form">
    <!--TODO Form Validation-->
    <form role="form" class="php-email-form" [formGroup]="customerform" (ngSubmit)="this.onSubmit()">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="display_name" class="form-label">
            Anzeigename
          </label>
          <input type="text" name="display_name" class="form-control" id="display_name"
                 placeholder="Anzeigename*" formControlName="display_name" required
                 [class.is-invalid]="(this.getFormControls()['display_name'].touched || this.getFormControls()['display_name'].dirty) && this.getFormControls()['display_name'].invalid">
          <div *ngIf="this.getFormControls()['display_name'].touched && this.getFormControls()['display_name'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['display_name'].errors?.['required']">Der Titel ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['display_name'].errors?.['pattern']">Der Titel enthält ein ungültiges Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['display_name'].errors?.['minlength']">Der eingegebene Titel ist zu kurz</div>
          </div>
        </div>

        <div class="form-group col-md-6">
          <label for="company_name" class="form-label">
          Firmenname
          </label>
          <input type="text" name="company_name" class="form-control" id="company_name"
                 placeholder="User ID" formControlName="company_name"
                 [class.is-invalid]="(this.getFormControls()['company_name'].touched || this.getFormControls()['company_name'].dirty) && this.getFormControls()['company_name'].invalid">
          <div *ngIf="this.getFormControls()['company_name'].touched && this.getFormControls()['company_name'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['useruuid'].errors?.['pattern']">Die User ID enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['useruuid'].errors?.['minlength']">Die User ID ist zu kurz</div>
            <div *ngIf="this.getFormControls()['useruuid'].errors?.['maxlength']">Die User ID ist zu lang</div>
          </div>
        </div>

        <div class="form-group col-md-3">
          <label for="zipcode" class="form-label">
            Postleizahl
          </label>
          <input type="number" class="form-control" name="zipcode" id="zipcode"
                 placeholder="Postleizahl" formControlName="zipcode"
                 [class.is-invalid]="(this.getFormControls()['zipcode'].touched || this.getFormControls()['zipcode'].dirty) && this.getFormControls()['zipcode'].invalid">
          <div *ngIf="this.getFormControls()['zipcode'].touched && this.getFormControls()['zipcode'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['zipcode'].errors?.['minlength']">Die eingegebene Postleizahl ist zu
              kurz
            </div>
            <div *ngIf="this.getFormControls()['zipcode'].errors?.['maxlength']">Die eingegebene Postleizahl ist zu
              lang
            </div>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="city" class="form-label">
            Stadt
          </label>
          <input type="text" class="form-control" name="city" id="city"
                 placeholder="Stadt"
                 formControlName="city"
                 [class.is-invalid]="(this.getFormControls()['city'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['city'].invalid">
          <div
            *ngIf="(this.getFormControls()['city'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['city'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['city'].errors?.['required']">Die Stadt ist leider erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-3">
          <label for="district" class="form-label">
            Bezirk/Distrikt
          </label>
          <input type="text" class="form-control" name="district" id="district"
                 placeholder="Distrikt/Bezirk/Stadtteil"
                 formControlName="district"
                 [class.is-invalid]="(this.getFormControls()['district'].touched || this.getFormControls()['district'].dirty) && this.getFormControls()['district'].invalid && this.getFormControls()['district'].hasValidator(Validators.required)">
          <div
            *ngIf="(this.getFormControls()['district'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['district'].invalid && this.getFormControls()['district'].hasValidator(Validators.required)"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['district'].errors?.['required']">Distrikt/Bezirk/Stadtteil ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-3">
          <label for="street" class="form-label">
            Straße
          </label>
          <input type="text" class="form-control" name="street" id="street"
                 placeholder="Straße"
                 formControlName="street"
                 [class.is-invalid]="(this.getFormControls()['street'].touched || this.getFormControls()['street'].dirty) && this.getFormControls()['street'].invalid">
          <div
            *ngIf="(this.getFormControls()['street'].touched || this.getFormControls()['street'].dirty) && this.getFormControls()['street'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['street'].errors?.['required']">Die Straße  ist leider erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-3">
          <label for="archived" class="form-label">
            Archiviert*
          </label>
          <select class="form-control" name="archived" id="archived"
                  formControlName="archived" required
                  [class.is-invalid]="(this.getFormControls()['archived'].touched || this.getFormControls()['archived'].dirty) && this.getFormControls()['archived'].invalid">
            <option value="" selected disabled hidden="hidden">Archiviert ?</option>
            <option value="true">Ja</option>
            <option value="false">Nein</option>
          </select>
        </div>

        <div class="pb-3">
          <div *ngIf="this.sentstatus === 1" class="sent-message">Der Kunde wurde
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }}
          </div>
          <div *ngIf="this.sentstatus === 2" class="error-message">Der Kunde konnte leider nicht
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }} werden
          </div>
          <div *ngIf="this.sentstatus === 3" class="error-message">Sie haben zu viele Anfragen gestellt, bitte versuchen
            Sie es später nochmal
          </div>
        </div>
        <div class="text-center">
          <button *ngIf="this.operation === 'edit' || this.operation === 'create'" type="submit"
                  class="btn btn-success mb-3">Speichern
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
